function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShineMagic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.399 16.448A5.809 5.809 0 003.56 12.61L1.4 11.943a.211.211 0 010-.404l2.161-.667A5.809 5.809 0 007.4 7.034l.666-2.161c.061-.199.343-.199.404 0l.667 2.161a5.809 5.809 0 003.838 3.838l2.161.667c.2.061.199.343 0 .404l-2.16.667a5.81 5.81 0 00-3.84 3.838l-.666 2.161a.211.211 0 01-.404 0L7.4 16.448zm.731-1.758l.137.248.137-.248a7.18 7.18 0 012.813-2.812l.247-.137-.247-.137a7.18 7.18 0 01-2.813-2.813l-.137-.247-.137.247a7.18 7.18 0 01-2.812 2.813l-.248.137.248.137A7.18 7.18 0 018.13 14.69zM15 4.11c-.25.34-.55.64-.89.89.34.25.64.55.89.89.25-.34.55-.64.89-.89-.34-.25-.64-.55-.89-.89zm2.485 1.422a2.956 2.956 0 00-1.953 1.953l-.348 1.13a.192.192 0 01-.368 0l-.348-1.13a2.956 2.956 0 00-1.953-1.953l-1.13-.348a.192.192 0 010-.368l1.13-.348a2.956 2.956 0 001.953-1.953l.348-1.13c.055-.18.312-.18.368 0l.348 1.13a2.956 2.956 0 001.953 1.953l1.13.348c.18.056.18.312 0 .368l-.126.038-1.004.31z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 15.625H16.25V13.75H15v1.875h-1.875v1.25H15v1.875h1.25v-1.875h1.875v-1.25z",
    fill: props.color
  }));
}

export default SvgIconShineMagic;